<div class="report-wrapper">
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="ms-Spinner is-large"></div>
    <p class="loading-text">Cargando reporte analítico de forma segura...</p>
  </div>

  <div *ngIf="errorMessage" class="error-banner">
    <i class="ms-Icon ms-Icon--Warning alert-icon"></i>
    <p>{{ errorMessage }}</p>
  </div>

  <div #dashboardContainer class="superset-iframe-container" [hidden]="isLoading || errorMessage"></div>
</div>